import { ReactNode } from "react";
import { ChevronRightIcon } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
} from "@/components/ui/sidebar";

// Collapsible sidebar group with a second-level menu, built on the shadcn
// Sidebar + Collapsible primitives. See DESIGN.md "侧边栏". Used by Apps /
// Labels / Focus users. `renderItem` must return a <SidebarMenuItem> row.
export function SidebarNavGroup<T>({
  label,
  items,
  renderItem,
  headerAction,
  defaultOpen = true,
  hideWhenEmpty = false,
}: {
  label: string;
  items: T[];
  renderItem: (item: T) => ReactNode;
  headerAction?: ReactNode;
  defaultOpen?: boolean;
  hideWhenEmpty?: boolean;
}) {
  if (hideWhenEmpty && items.length === 0) return null;

  return (
    <Collapsible defaultOpen={defaultOpen} className="group/collapsible">
      <SidebarGroup className="py-1">
        <div className="flex items-center">
          <SidebarGroupLabel asChild className="flex-1 text-sm">
            <CollapsibleTrigger>
              {label}
              <ChevronRightIcon className="ml-auto h-4 w-4 transition-transform group-data-[state=open]/collapsible:rotate-90" />
            </CollapsibleTrigger>
          </SidebarGroupLabel>
          {headerAction}
        </div>
        <CollapsibleContent>
          <SidebarGroupContent>
            {/* 子级缩进：只缩进，不加左竖线（DESIGN.md） */}
            <SidebarMenu className="ml-3 mt-0.5 w-auto pl-2">
              {items.map(renderItem)}
            </SidebarMenu>
          </SidebarGroupContent>
        </CollapsibleContent>
      </SidebarGroup>
    </Collapsible>
  );
}

export default SidebarNavGroup;
